export type DialogType = 'info' | 'warning' | 'error';

export interface OverlayConfig {
  titleTrxId?: string;
  messageTrxId: string;
  actionTrxId?: string;
  closeable?: boolean;
  type: DialogType;
}

export const getOrganizationsError: OverlayConfig = {
  titleTrxId: 'errors.getOrganizationsError.title',
  messageTrxId: 'errors.getOrganizationsError.message',
  type: 'error',
};

export const registerUserError: OverlayConfig = {
  titleTrxId: 'errors.registerUserError.title',
  messageTrxId: 'errors.registerUserError.message',
  type: 'error',
  closeable: true,
};

export const passwordPolicyError: OverlayConfig = {
  titleTrxId: 'errors.passwordPolicyError.title',
  messageTrxId: 'errors.passwordPolicyError.message',
  type: 'error',
  closeable: true,
};

export const resetPasswordRequestError: OverlayConfig = {
  titleTrxId: 'errors.resetPasswordRequestError.title',
  messageTrxId: 'errors.resetPasswordRequestError.message',
  type: 'error',
  closeable: true,
};

export const changePasswordError: OverlayConfig = {
  titleTrxId: 'errors.changePasswordError.title',
  messageTrxId: 'errors.changePasswordError.message',
  type: 'error',
  closeable: true,
};

export const securityTokenMissingError: OverlayConfig = {
  titleTrxId: 'errors.securityTokenMissingError.title',
  messageTrxId: 'errors.securityTokenMissingError.message',
  type: 'error',
  closeable: true,
};

export const invalidInvitationLinkError: OverlayConfig = {
  titleTrxId: 'errors.invalidInvitationLinkError.title',
  messageTrxId: 'errors.invalidInvitationLinkError.message',
  type: 'error',
  closeable: true,
};

export const acceptInvitationError: OverlayConfig = {
  titleTrxId: 'errors.acceptInvitationError.title',
  messageTrxId: 'errors.acceptInvitationError.message',
  type: 'error',
  closeable: true,
};

export const getChargePointsError: OverlayConfig = {
  titleTrxId: 'errors.getChargePointsError.title',
  messageTrxId: 'errors.getChargePointsError.message',
  type: 'error',
};

export const unknownError: OverlayConfig = {
  titleTrxId: 'errors.unknownError.title',
  messageTrxId: 'errors.unknownError.message',
  type: 'error',
  closeable: true,
};

export const getSubscriptionsError: OverlayConfig = {
  titleTrxId: 'errors.getSubscriptionsError.title',
  messageTrxId: 'errors.getSubscriptionsError.message',
  type: 'error',
};

export const getDriverOrganizationError: OverlayConfig = {
  titleTrxId: 'errors.getDriverOrganizationError.title',
  messageTrxId: 'errors.getDriverOrganizationError.message',
  type: 'error',
};

export const inviteDriverError: OverlayConfig = {
  titleTrxId: 'errors.inviteDriverError.title',
  messageTrxId: 'errors.inviteDriverError.message',
  type: 'error',
  closeable: true,
};

export const invitationExistsError: OverlayConfig = {
  titleTrxId: 'errors.invitationExistsError.title',
  messageTrxId: 'errors.invitationExistsError.message',
  type: 'error',
  closeable: true,
};

export const removeEdiKeyError: OverlayConfig = {
  titleTrxId: 'errors.removeEdiKeyError.title',
  messageTrxId: 'errors.removeEdiKeyError.message',
  type: 'error',
  closeable: true,
};

export const ediKeyStillInUseError: OverlayConfig = {
  titleTrxId: 'errors.ediKeyStillInUseError.title',
  messageTrxId: 'errors.ediKeyStillInUseError.message',
  type: 'error',
  closeable: true,
};

export const addEdiKeyError: OverlayConfig = {
  titleTrxId: 'errors.addEdiKeyError.title',
  messageTrxId: 'errors.addEdiKeyError.message',
  type: 'error',
  closeable: true,
};

export const ediKeyExistsError: OverlayConfig = {
  titleTrxId: 'errors.ediKeyExistsError.title',
  messageTrxId: 'errors.ediKeyExistsError.message',
  type: 'error',
  closeable: true,
};

export const updatingSettingsError: OverlayConfig = {
  titleTrxId: 'errors.updatingSettingsError.title',
  messageTrxId: 'errors.updatingSettingsError.message',
  type: 'error',
  closeable: true,
};

export const getBackendProviderError: OverlayConfig = {
  titleTrxId: 'errors.getBackendProviderError.title',
  messageTrxId: 'errors.getBackendProviderError.message',
  type: 'error',
  closeable: true,
};

export const updateBackendProviderError: OverlayConfig = {
  titleTrxId: 'errors.updateBackendProviderError.title',
  messageTrxId: 'errors.updateBackendProviderError.message',
  type: 'error',
  closeable: true,
};

export const updateAutomaticCompanyCarError: OverlayConfig = {
  titleTrxId: 'errors.updateAutomaticCompanyCarError.title',
  messageTrxId: 'errors.updateAutomaticCompanyCarError.message',
  type: 'error',
  closeable: true,
};

export const getManagersError: OverlayConfig = {
  titleTrxId: 'errors.getManagersError.title',
  messageTrxId: 'errors.getManagersError.message',
  type: 'error',
};

export const deleteMemberError: OverlayConfig = {
  titleTrxId: 'errors.deleteMemberError.title',
  messageTrxId: 'errors.deleteMemberError.message',
  type: 'error',
};

export const inviteMemberError: OverlayConfig = {
  titleTrxId: 'errors.inviteMemberError.title',
  messageTrxId: 'errors.inviteMemberError.message',
  type: 'error',
};

export const upgradeSubscriptionError: OverlayConfig = {
  titleTrxId: 'errors.upgradeSubscriptionError.title',
  messageTrxId: 'errors.upgradeSubscriptionError.message',
  type: 'error',
};

export const deleteReceiverError: OverlayConfig = {
  titleTrxId: 'errors.deleteReceiverError.title',
  messageTrxId: 'errors.deleteReceiverError.message',
  type: 'error',
};

export const automaticExportMissmatchError: OverlayConfig = {
  titleTrxId: 'errors.automaticExportMissmatchError.title',
  messageTrxId: 'errors.automaticExportMissmatchError.message',
  type: 'error',
};

export const getChargingEventsError: OverlayConfig = {
  titleTrxId: 'errors.getChargingEventsError.title',
  messageTrxId: 'errors.getChargingEventsError.message',
  type: 'error',
};

export const downloadChargingEventsCsvError: OverlayConfig = {
  titleTrxId: 'errors.downloadChargingEventsCsvError.title',
  messageTrxId: 'errors.downloadChargingEventsCsvError.message',
  type: 'error',
  closeable: true,
};

export const downloadExportError: OverlayConfig = {
  titleTrxId: 'errors.downloadExportError.title',
  messageTrxId: 'errors.downloadExportError.message',
  type: 'error',
  closeable: true,
};

export const updateProfileError: OverlayConfig = {
  titleTrxId: 'errors.updateProfileError.title',
  messageTrxId: 'errors.updateProfileError.message',
  type: 'error',
  closeable: true,
};

export const updateLanguageError: OverlayConfig = {
  titleTrxId: 'errors.updateLanguageError.title',
  messageTrxId: 'errors.updateLanguageError.message',
  type: 'error',
  closeable: true,
};

export const refreshTokenError: OverlayConfig = {
  titleTrxId: 'errors.refreshTokenError.title',
  messageTrxId: 'errors.refreshTokenError.message',
  type: 'error',
};

export const getMileagesError: OverlayConfig = {
  titleTrxId: 'errors.getMileagesError.title',
  messageTrxId: 'errors.getMileagesError.message',
  type: 'error',
};

export const carNotFoundError: OverlayConfig = {
  titleTrxId: 'errors.carNotFoundError.title',
  messageTrxId: 'errors.carNotFoundError.message',
  type: 'error',
};

export const getDriverKeysError: OverlayConfig = {
  titleTrxId: 'errors.getDriverKeysError.title',
  messageTrxId: 'errors.getDriverKeysError.message',
  type: 'error',
  closeable: true,
};

export const invalidInputError: OverlayConfig = {
  titleTrxId: 'errors.invalidInputError.title',
  messageTrxId: 'errors.invalidInputError.message',
  type: 'error',
  closeable: true,
};

export const saveDriverKeyError: OverlayConfig = {
  titleTrxId: 'errors.saveDriverKeyError.title',
  messageTrxId: 'errors.saveDriverKeyError.message',
  type: 'error',
  closeable: true,
};

export const getLatestPriceError: OverlayConfig = {
  titleTrxId: 'errors.getLatestPriceError.title',
  messageTrxId: 'errors.getLatestPriceError.message',
  type: 'error',
  closeable: true,
};

export const getFlatratePricesError: OverlayConfig = {
  titleTrxId: 'errors.getFlatratePricesError.title',
  messageTrxId: 'errors.getFlatratePricesError.message',
  type: 'error',
  closeable: true,
};

export const createPricePolicyError: OverlayConfig = {
  titleTrxId: 'errors.createPricePolicyError.title',
  messageTrxId: 'errors.createPricePolicyError.message',
  type: 'error',
  closeable: true,
};

export const assignSeatError: OverlayConfig = {
  titleTrxId: 'errors.assignSeatError.title',
  messageTrxId: 'errors.assignSeatError.message',
  type: 'error',
  closeable: true,
};

export const unassignSeatError: OverlayConfig = {
  titleTrxId: 'errors.unassignSeatError.title',
  messageTrxId: 'errors.unassignSeatError.message',
  type: 'error',
  closeable: true,
};

export const deleteDriverInvitationError: OverlayConfig = {
  titleTrxId: 'errors.deleteDriverInvitationError.title',
  messageTrxId: 'errors.deleteDriverInvitationError.message',
  type: 'error',
  closeable: true,
};

export const userNotFoundError: OverlayConfig = {
  titleTrxId: 'errors.userNotFoundError.title',
  messageTrxId: 'errors.userNotFoundError.message',
  type: 'error',
  closeable: true,
};

export const getEnergyContractError: OverlayConfig = {
  titleTrxId: 'errors.getEnergyContractError.title',
  messageTrxId: 'errors.getEnergyContractError.message',
  type: 'error',
  closeable: true,
};

export const getChargingStationBackendDataError: OverlayConfig = {
  titleTrxId: 'errors.getChargingStationBackendDataError.title',
  messageTrxId: 'errors.getChargingStationBackendDataError.message',
  type: 'error',
  closeable: true,
};

export const saveChargingStationBackendDataError: OverlayConfig = {
  titleTrxId: 'errors.saveChargingStationBackendDataError.title',
  messageTrxId: 'errors.saveChargingStationBackendDataError.message',
  type: 'error',
  closeable: true,
};

export const getReimbursementsError: OverlayConfig = {
  titleTrxId: 'errors.getReimbursementsError.title',
  messageTrxId: 'errors.getReimbursementsError.message',
  type: 'error',
};

export const getConfigCodeError: OverlayConfig = {
  titleTrxId: 'errors.getConfigCodeError.title',
  messageTrxId: 'errors.getConfigCodeError.message',
  type: 'error',
  closeable: true,
};

export const getChargePointDetailError: OverlayConfig = {
  titleTrxId: 'errors.getChargePointDetailError.title',
  messageTrxId: 'errors.getChargePointDetailError.message',
  type: 'error',
  closeable: true,
};

export const alreadyExportedError: OverlayConfig = {
  titleTrxId: 'errors.alreadyExportedError.title',
  messageTrxId: 'errors.alreadyExportedError.message',
  type: 'error',
  closeable: true,
};

export const automaticExportActiveError: OverlayConfig = {
  titleTrxId: 'errors.automaticExportActiveError.title',
  messageTrxId: 'errors.automaticExportActiveError.message',
  type: 'error',
  closeable: true,
};

export const exportError: OverlayConfig = {
  titleTrxId: 'errors.exportError.title',
  messageTrxId: 'errors.exportError.message',
  type: 'error',
  closeable: true,
};

export const testBackendProviderConnectionError: OverlayConfig = {
  titleTrxId: 'errors.testBackendProviderConnectionError.title',
  messageTrxId: 'errors.testBackendProviderConnectionError.message',
  type: 'error',
  closeable: true,
};
